import { Divider } from "@mui/material";
import React, { useState } from "react";
import DataCard from "../DataCard";
import FromData from "./FormCard";
import { message } from "antd";
import { gettitle } from "../../../../utils/getImages";

const Level2SubCard = ({
  attributes,
  dataCard,
  setDataCard,
  pageData,
  setPageData,
  slug
}) => {
  const [activeSection, setActiveSection] = useState();
  const addData = (index, cardData, type) => {
    let array = [];
    if (type) {
      array = [...dataCard.dataArray];
      array[index] = cardData;
    } else if (dataCard.dataArray) array = [...dataCard.dataArray, cardData];
    else array = [cardData];
    setDataCard({ ...dataCard, dataArray: array });
    if (type) {
      message.success("data updated click on publish to publish changes");
    } else {
      message.success("Created");
    }
  };

  const handleUp = (index) => {
    let arr = dataCard?.dataArray;
    if (index > 0) {
      let val = dataCard?.dataArray[index];
      let val1 = dataCard?.dataArray[index - 1];
      arr[index] = val1;
      arr[index - 1] = val;
      setDataCard({ ...dataCard, dataArray: arr });
    }
  };

  const handleDown = (index) => {
    let arr = dataCard?.dataArray;
    if (index < arr.length - 1) {
      let val = dataCard?.dataArray[index];
      let val1 = dataCard?.dataArray[index + 1];
      arr[index] = val1;
      arr[index + 1] = val;
      setDataCard({ ...dataCard, dataArray: arr });
    }
  };

  const handleStatus = (index) => {
    const updatedArray = [...dataCard.dataArray];
    updatedArray[index] = {
      ...updatedArray[index],
      status: !updatedArray[index].status,
    };
    setDataCard({ ...dataCard, dataArray: updatedArray });
  };
  return (
    <div style={{ borderRadius: "5px", overflow: "hidden", padding: "10px" }}>
      <Divider sx={{ borderStyle: "dashed", marginBottom: "20px" }} />

      <div>
        <div>
          <div className="row">
            <div className="col-lg-12">
              {dataCard?.dataArray?.map((item, index) => {
                return (
                  <DataCard
                    slug={slug}
                    handleStatus={handleStatus}
                    color="#f7f7f7"
                    title={gettitle(item,slug)}
                    activeDrop={activeSection}
                    handleup={handleUp}
                    handledown={handleDown}
                    setActiveDrop={setActiveSection}
                    index={index}
                    array={dataCard?.dataArray}
                    setArray={(e) => {
                      setDataCard({ ...dataCard, dataArray: e });
                    }}
                  >
                    <FromData
                      active={activeSection == index}
                      attributes={attributes}
                      data={item}
                      updateData={addData}
                      index={index + 1}
                    />
                  </DataCard>
                );
              })}
            </div>
            <div style={{ margin: "10px", width: "100%" }}>
              <FromData add updateData={addData} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Level2SubCard;
